import React from "react";

export default function CommentAvatar({ name, src, size = 28 }) {
  const [errored, setErrored] = React.useState(false);

  const initials = (name || "")
    .split(" ")
    .map((s) => s[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();

  if (!src || errored) {
    return (
      <div
        className="flex shrink-0 items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
        style={{ width: size, height: size }}
        title={name}
        aria-hidden={!name}
      >
        {initials ? (
          <span className="text-[10px] font-semibold">{initials}</span>
        ) : (
          <svg
            width={Math.floor(size * 0.6)}
            height={Math.floor(size * 0.6)}
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
          </svg>
        )}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name || ""}
      title={name}
      loading="lazy"
      referrerPolicy="no-referrer"
      className="shrink-0 rounded-full border border-gray-300 bg-white object-cover"
      style={{ width: size, height: size }}
      onError={() => setErrored(true)}
    />
  );
}
